module.exports = __webpack_public_path__ + "static/media/63532a0b1ca643d86dc10decb3e9ab2f_html_b0d4303a5f7cab52.76ad25d5.png";